import Barba from 'barba.js';
import setVideoRatio from "../scripts/setVideoRatio";
import { manager, menu } from './../app'
import VerticalSlider from "../classes/VerticalSlider";

const PageTransition = Barba.BaseTransition.extend({
    done() {
        this.oldContainer.parentNode.removeChild(this.oldContainer);
        this.newContainer.style.display = 'block';
        this.deferred.resolve();
    },
    start() {
        if( menu.isOpen ) {
            this.newContainerLoading.then(this.finish.bind(this));
            return;
        }

        if( manager ) {
            let last = manager.lastTransition.tl;
            let _this = this;
            last.eventCallback('onReverseComplete', () => {
                _this.newContainerLoading.then(_this.finish.bind(_this));
            });
            last.reverse();
        } else {
            this.newContainerLoading.then(this.finish.bind(this));
        }
    },
    finish() {
        window.scrollTo(0,0);
        menu.onClose( () => {
            manager.playPageTransition();
            if( document.querySelector('.vertical-slider') ) {
                manager.slider = new VerticalSlider();
            }
        } );
        this.done();
        if( menu.isOpen ) {
            menu.close();
            if( manager ) {
                manager.restartSlider();
                setVideoRatio();
            }
        } else if( manager ) {
            manager.restartSlider();
            manager.playPageTransition();
            if( document.querySelector('.vertical-slider') ) {
                manager.slider = new VerticalSlider();
            }

            setVideoRatio();
        }
    }
});

export default PageTransition;